import productSuggest from 'components/product/product-suggest.vue';

Vue.component('product-suggest', productSuggest);

new Vue({
    el: '#st-suggested-products'
});

document.addEventListener('DOMContentLoaded', () => {
    const button = document.getElementById('trackRowExpander'),
          container = document.getElementById('trackRowContainer'),
          expandText = document.querySelector('.st-tr__expand'),
          collapseText = document.querySelector('.st-tr__collapse'),
          containerHeight = getContainerHeight();

    let expanded = false;

    // Check shipping detail container height so we can animate it later
    function getContainerHeight() {
        var height = '';
        if(container){
            container.style.maxHeight = 'none';
            height = container.offsetHeight;
            container.style.maxHeight = '';
            container.classList.add('height-checked');
            return `${height}px`;
        }
    }

    // Focus on container toggle
    function focusOnButton() {
        setTimeout(() => {
            document.activeElement.blur();
        }, 510);
        setTimeout(() => {
            button.focus();
            if (expanded) {
                button.scrollIntoView({ behavior: 'smooth' });
            }
        }, 550);
    }

    // Set container class and button attributes when expanded/collapsed
    function setExpandedAttrs(collapse) {
        setTimeout(() => {
            if (collapse === true || expanded) {
                container.classList.remove('expanded');
                button.setAttribute('aria-expanded', 'false');
                button.setAttribute('aria-label', 'Shipping details are collapsed. Click here to expand.');
            } else {
                container.classList.add('expanded');
                button.setAttribute('aria-expanded', 'true');
                button.setAttribute('aria-label', 'Shipping details are expanded. Advance to navigate through shipping details table. Click here or press escape to collapse.');
            }
        }, 500);
    }

    // Expand the container
    function expand(e = false) {
        expanded = true;
        if (e) {
            e.preventDefault();
            focusOnButton();
        }
        container.style.maxHeight = '0';
        container.style.maxHeight = containerHeight;
        container.setAttribute('aria-hidden', 'false');
        expandText.classList.remove('active');
        collapseText.classList.add('active');
        setExpandedAttrs();
    }

    // Collapse the container
    function collapse(e) {
        if ( e.type === 'click' 
            || (e.key === 'Escape' 
                && (container.contains(document.activeElement) 
                    || button.contains(document.activeElement)))
            ) {
            expanded = false;
            e.preventDefault();
            container.style.maxHeight = containerHeight;
            container.style.maxHeight = '0';
            container.setAttribute('aria-hidden', 'true');
            expandText.classList.add('active');
            collapseText.classList.remove('active');
            setExpandedAttrs(true);
            focusOnButton();
        }
    }

    // Toggle function for event listener
    const showHide = (e) => {
        if (!expanded) {
            expand(e);
            document.addEventListener('keydown', collapse);
        } else {
            collapse(e);
            document.removeEventListener('keydown', collapse);
        }
    }

    // Get URL params
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    if (button && container) {
        // Check for expand param
        if (params.expandShippingDetails === '1') {
            expand();
        }

        // Expand/Collapse on button click
        button.addEventListener('click', showHide);
    }
});